<template>
  <v-card :color="backgroundColor || $vuetify.theme.currentTheme.background">
    <v-card-title>
      <v-btn
        icon
        v-if="backButton"
        @click="clickBack"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span @dblclick="handleTitleDblClick">
        {{ title }}
      </span>
      <v-spacer />
      <v-btn
        icon
        @click="close"
        v-if="!cancelButton"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="px-0">
      <slot name="content" />
    </v-card-text>
    <v-card-actions
      class="pb-4 px-6"
      v-if="showActions"
    >
      <slot name="actions" />
      <template v-if="actionsButtons.length > 0">
        <v-spacer />
        <eva-button
          v-if="cancelButton"
          @click="close"
          :label="$t('cancel')"
        />

        <eva-button
          v-for="(button, index) in actionsButtons"
          :key="index"
          :primary="button.primary"
          @click="button.action"
          :disabled="button.disabled"
          :loading="button.loading"
          :color="button.color"
          class="ml-2"
          :label="button.label"
          v-tooltip="button.tooltip"
        />
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "EvaStepDialog",
  props: {
    title: {
      type: String,
      required: true,
    },
    backButton: {
      type: Boolean,
      default: false,
    },
    // Hide the close button if true
    cancelButton: {
      type: Boolean,
      default: false,
    },
    // Array of objects with the following structure:
    // {
    //   label: String,
    //   primary: Boolean,
    //   action: Function,
    //   disabled: Boolean,
    //   loading: Boolean,
    //   tooltip: String,
    // }
    actionsButtons: {
      type: Array,
      default: () => [],
    },
    backgroundColor: {
      type: String,
      default: null,
    },
  },
  emits: ["close", "back", "dblclick:title"],
  computed: {
    showActions() {
      return this.actionsButtons.length > 0 || this.$slots.actions
    },
  },
  methods: {
    close() {
      this.$emit("close")
    },
    clickBack() {
      this.$emit("back")
    },
    handleTitleDblClick() {
      this.$emit("dblclick:title")
    },
  },
}
</script>

<style scoped></style>
